import React from 'react'
import ReactDOM from 'react-dom/client'
import { BreadcrumbTrail } from '@ampcore/design-system'

export class BreadcrumbTrailElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'breadcrumb-trail-element'
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)
    const linksAttr = this.getAttribute('data-links') || ''
    const decodedLinksAttr = linksAttr.replace(/\\'/g, "'") // remove JS escape for apostrophes
    const links = JSON.parse(decodedLinksAttr)
    const isDisabled = this.getAttribute('data-is-disabled') === 'true'
    const isReversed = this.getAttribute('data-is-reversed') === 'true'

    const root = ReactDOM.createRoot(reactContainer)
    root.render(
      <BreadcrumbTrail
        links={links}
        isDisabled={isDisabled}
        isReversed={isReversed}
      />
    )
  }
}
